import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import EmployeeContractsIndexContainer from '../containers/EmployeeContracts/EmployeeContractsIndexContainer'
import EmployeeContractFormContainer from '../containers/EmployeeContracts/EmployeeContractFormContainer'
import { HR_ROLES } from '../containers/EmployeeContracts/graphql'
import { withAuthorization } from '../containers/Authorization'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const EmployeeContractsIndex = withAuthorization(EmployeeContractsIndexContainer, HR_ROLES)
const EmployeeContractForm = withAuthorization(EmployeeContractFormContainer, HR_ROLES)

const EmployeeContractsPage = ({
  location,
  match
}) => {
  const dispatch = useDispatch()
  const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
  const { pathname } = location

  useEffect(() => {
    if (current[0] !== 'employee_contracts') {
      dispatch(changeCurrent(['employee_contracts']))
    }
  }, [pathname])

  const path = match.url

  return (
    <Switch>
      <Route path={`${path}/`} component={EmployeeContractsIndex} exact />
      <Route path={`${path}/new`} component={EmployeeContractForm} />
      <Route path={`${path}/:id/edit`} component={EmployeeContractForm} />
    </Switch>
  )
}

EmployeeContractsPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

EmployeeContractsPage.defaultProps = {}

export default EmployeeContractsPage
